<template>
  <div class="legend-container">
    <div class="legend-title">区域表示区分</div>
    <div class="legend-items">
      <div class="legend-item">
        <div class="colorbox_border blue">
        </div>
        <div class="legend-text">開発</div>
      </div>
      <div class="legend-item">
        <div class="colorbox_border green">
        </div>
        <div class="legend-text">旧宅地造成</div>
      </div>
      <div class="legend-item">
        <div class="colorbox_border orange">
        </div>
        <div class="legend-text">宅地造成・農地造成・森林造成</div>
      </div>
      <div class="legend-item">
        <div class="colorbox_border purple">
        </div>
        <div class="legend-text">土石の堆積</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapObjectGuideKaihatsuTakuzo'
}
</script>

<style scoped>
.legend-container {
  background: #ddeeee;
  padding: 16px;
  border-radius: 8px;
  max-width: 360px;
}

.legend-title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.colorbox_border {
  width: 35px;
  height: 20px;
  position: relative;
  border: 2px solid;
  background-color: white !important;
}

.legend-container .legend-items .legend-item .colorbox_border {
  background-color: white;
}

.colorbox_border.blue { 
  border-color: rgb(0,0,255) !important; 
  background-color: rgba(0,0,255,0.1) !important;
}
.colorbox_border.green { 
  border-color: rgb(0,255,0) !important;
  background-color: rgba(0,255,0,0.1) !important;
}
.colorbox_border.orange { 
  border-color: rgb(255,165,0) !important;
  background-color: rgba(255,165,0,0.1) !important;
}
.colorbox_border.purple { 
  border-color: rgb(200,0,200) !important;
  background-color: rgba(200,0,200,0.1) !important;
}

.legend-text {
  font-size: 0.8rem;
}
</style> 